import { useQuery } from 'react-query';
import { httpService } from '../../services/http.service';
import { BASE_URL, USER } from '../../constants/endpoints';
import { HOOKS_SETTINGS } from '../constants';
import { IAddressObject } from '../../types';

const {
  METHOD: { POST },
} = HOOKS_SETTINGS;
const {
  CONTROLLERS: {
    UPDATE_ADDRESS: { BASE, VERSION },
  },
} = USER;
export const useUpdateAddress = ({
  customerId,
  dataObj,
  onSuccess,
  onError,
}: {
  customerId: string;
  dataObj: IAddressObject;
  onSuccess?: () => void;
  onError?: (err: any) => void;
}) =>
  useQuery(
    ['setAutoSavings'],
    async () => {
      if (!customerId) {
        return '';
      }
      const { data } = await httpService({
        url: `${BASE_URL}/api/${VERSION}/user/${customerId}/${BASE}`,
        method: POST,
        data: {
          city: `${dataObj.city}`,
          state: `${dataObj.state}`,
          line1: `${dataObj.street_address}`,
          line2: `${dataObj.apt_suite}`,
          postalCode: `${dataObj.zip_code}`,
          country: 'US',
        },
      });
      return data;
    },
    {
      cacheTime: 0,
      enabled: false,
      retry: 0,
      onSuccess: () => {
        if (onSuccess) onSuccess();
      },
      onError: (err) => {
        if (onError) onError(err);
      },
    },
  );
